import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Search, ShoppingBag, User, LogOut, Package, LayoutDashboard } from "lucide-react";
import { useStore } from "../context/Store";
import { LOGO, CURRENCIES } from "../lib/api";

export const CATS = [
  ["clothing", "Clothing"], ["fashion", "Fashion"], ["makeup", "Makeup"], ["appliances", "Appliances"],
  ["home", "Home"], ["electronics", "Electronics"], ["kids", "Kids"], ["sports", "Sports"],
];

export const Header = () => {
  const { count, setCartOpen, currency, setCurrency, user, signOut } = useStore();
  const [q, setQ] = useState("");
  const nav = useNavigate();
  const submit = (e) => { e.preventDefault(); nav(`/shop?q=${encodeURIComponent(q)}`); };

  return (
    <header className="sticky top-0 z-40 bg-[#FAF7F2]/90 backdrop-blur-md border-b border-[#C85A32]/15">
      <div className="bg-[#1A1714] text-[#F3E3C3] text-xs py-1.5 text-center tracking-wide" data-testid="promo-strip">
        Free delivery on orders over $50 · Pay with M-Pesa, EcoCash, MoMo, PayPal & Card
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 h-16 flex items-center gap-4">
        <Link to="/" className="flex items-center gap-2 shrink-0" data-testid="header-logo-link">
          <img src={LOGO} alt="Afri-go" className="w-10 h-10 rounded-full object-cover scale-110" />
          <span className="font-display text-2xl font-extrabold tracking-tight text-[#1A1714]">Afri<span className="text-[#C85A32]">-go</span></span>
        </Link>
        <form onSubmit={submit} className="flex-1 hidden md:flex items-center bg-white rounded-full border border-[#C85A32]/20 px-4 h-11 focus-within:ring-2 focus-within:ring-[#C85A32]/40 transition-shadow">
          <Search className="w-4 h-4 text-stone-400" />
          <input data-testid="header-search-input" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search dresses, blenders, lipstick..." className="flex-1 bg-transparent outline-none px-3 text-sm" />
        </form>
        <select data-testid="currency-switcher" value={currency} onChange={(e) => setCurrency(e.target.value)} className="h-10 rounded-full bg-white border border-[#C85A32]/20 px-3 text-sm font-semibold cursor-pointer">
          {Object.keys(CURRENCIES).map((c) => <option key={c} value={c}>{c}</option>)}
        </select>
        {user ? (
          <div className="flex items-center gap-1">
            {user.role === "admin" && <Link to="/admin" data-testid="header-admin-link" className="p-2 rounded-full hover:bg-[#C85A32]/10 transition-colors" title="Admin"><LayoutDashboard className="w-5 h-5" /></Link>}
            <Link to="/orders" data-testid="header-orders-link" className="p-2 rounded-full hover:bg-[#C85A32]/10 transition-colors" title="My orders"><Package className="w-5 h-5" /></Link>
            <button data-testid="header-logout-btn" onClick={signOut} className="p-2 rounded-full hover:bg-[#C85A32]/10 transition-colors" title="Log out"><LogOut className="w-5 h-5" /></button>
          </div>
        ) : (
          <Link to="/login" data-testid="header-login-link" className="flex items-center gap-1.5 text-sm font-semibold hover:text-[#C85A32] transition-colors"><User className="w-5 h-5" /><span className="hidden sm:inline">Sign in</span></Link>
        )}
        <button data-testid="header-cart-btn" onClick={() => setCartOpen(true)} className="relative p-2.5 rounded-full bg-[#C85A32] text-white hover:bg-[#A9481F] transition-colors">
          <ShoppingBag className="w-5 h-5" />
          {count > 0 && <span data-testid="cart-count-badge" className="absolute -top-1 -right-1 bg-[#D99B26] text-[#1A1714] text-[10px] font-bold w-5 h-5 rounded-full grid place-items-center">{count}</span>}
        </button>
      </div>
      <nav className="max-w-7xl mx-auto px-4 sm:px-6 flex gap-6 overflow-x-auto text-sm font-medium pb-2 no-scrollbar">
        {CATS.map(([slug, name]) => (
          <Link key={slug} to={`/shop?category=${slug}`} data-testid={`nav-cat-${slug}`} className="whitespace-nowrap text-stone-600 hover:text-[#C85A32] transition-colors">{name}</Link>
        ))}
      </nav>
    </header>
  );
};
